<template>
  <h4 class="font-roboto text-lg font-bold mb-2">
    Author contributions
  </h4>
  <p class="mb-4">
    Chemical Science requires authors to include an "Author contributions" section in their manuscript, using
    <a
      id="lnk-mainArticleUpload-casraiSite"
      href="https://credit.niso.org/"
      class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
      target="_blank">CRediT</a>
    for standardised contribution descriptions. Individual contributions should accurately reflect contributions to the work and be agreed by all authors before submission (see
    <a
      href="https://www.rsc.org/publishing/journals/processes-and-policies/author-responsibilities"
      target="_blank"
      class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
      id="lnk-mainArticleUpload-rscAuthorship"
    >author
      guidelines</a>
    for more information).
  </p>
</template>
